"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddHistoricalPoliciesModal = void 0;
/* eslint-disable @typescript-eslint/no-floating-promises */
var core_ui_1 = require("@newfront-insurance/core-ui");
var next_newfront_api_1 = require("@newfront-insurance/next-newfront-api");
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var yup = __importStar(require("yup"));
var carrier_select_1 = require("../../legacy/components/carrier-select");
var wholesaler_select_1 = require("../../legacy/components/wholesaler-select");
var create_historical_policy_1 = require("../../mutations/create-historical-policy");
var policy_term_fields_1 = require("../policy-term-fields");
var legacy_1 = require("../policy-term-select/legacy");
var policy_type_select_input_1 = require("../policy-type-select-input");
var schema = yup.object().shape({
    accountUuid: yup.string().required('Account uuid is required'),
    effectiveDate: yup.string().required('Effective date is required'),
    expirationDate: yup.string().required('Expiration date is required'),
    type: yup.string().required('Policy type is required'),
    policyNumber: yup.string().required('Policy number is required'),
    premium: yup.number().required('Premium is required'),
    policyTerm: yup.string().required('Policy term is required'),
    marketAccess: yup.object().shape({
        carrier: yup.object().shape({
            id: yup.string().required('Carrier id is required'),
            name: yup.string().required('Carrier is required'),
        }),
        wholesaler: yup.object().shape({
            id: yup.string().nullable(),
            name: yup.string().nullable(),
        }),
    }),
});
/**
 * AddHistoricalPoliciesModal
 * Note. This is a copy of the newfront-app component
 * https://github.com/newfront-insurance/newfront-app/blob/master/packages/app/src/features/admin-client-details/components/policies-tab/components/create-historical-policy-modal/index.tsx#L61
 */
function AddHistoricalPoliciesModal(_a) {
    var _b, _c, _d, _e, _f;
    var accountUuid = _a.accountUuid, header = _a.header, isOpen = _a.isOpen, onSubmitSuccess = _a.onSubmitSuccess, successNotificationMessage = _a.successNotificationMessage, onToggle = _a.onToggle, submitText = _a.submitText;
    var _g = react_1.useState(false), isSubmitting = _g[0], setIsSubmitting = _g[1];
    var insuranceProvidersData = next_newfront_api_1.useInsuranceProviders({ suspense: true }).data;
    var createHistoricalPolicy = create_historical_policy_1.useCreateHistoricalPolicy()[0];
    var notifications = next_notifications_1.useNotifications();
    /**
     * Make sure form is reset on toggle
     */
    function handleToggle() {
        if (form)
            form.resetForm();
        onToggle();
    }
    /**
     * handleCreateHistoricalPolicy
     * Pass policyFields to createHistoricalPolicy (coverage service)
     * If there's a result and it has an id, return the EnrichedPolicy to onSubmit handler
     * Otherwise show error notification
     * @param policyFields - form data (excluding lineOfCoverageId)
     */
    function handleCreateHistoricalPolicy(policyFields) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsSubmitting(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createHistoricalPolicy({ body: policyFields, successNotificationMessage: successNotificationMessage })];
                    case 2:
                        _a.sent();
                        onSubmitSuccess();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        notifications.add({
                            type: 'error',
                            title: "Could not a create historical policy, " + err_1,
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        setIsSubmitting(false);
                        handleToggle();
                        return [2 /*return*/];
                }
            });
        });
    }
    var initialValues = {
        accountUuid: accountUuid,
        effectiveDate: '',
        expirationDate: '',
        type: '',
        policyNumber: '',
        premium: null,
        policyTerm: 'Other',
        marketAccess: {
            carrier: {
                name: '',
                id: '',
            },
        },
    };
    var form = formik_1.useFormik({
        initialValues: initialValues,
        onSubmit: handleCreateHistoricalPolicy,
        validationSchema: schema,
        validateOnChange: true,
    });
    return (react_1.default.createElement(core_ui_1.Modal, { isOpen: isOpen, onToggle: handleToggle, width: "600px" },
        react_1.default.createElement("form", { onSubmit: form.handleSubmit },
            react_1.default.createElement(core_ui_1.ModalBody, null,
                react_1.default.createElement(core_ui_1.ModalHeader, { titleText: header, onClose: handleToggle }),
                react_1.default.createElement(core_ui_1.Padding, { size: 24 },
                    react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "vertical" },
                        react_1.default.createElement(core_ui_1.Field, { label: "Policy number", fieldId: "policyNumber", error: form.errors.policyNumber },
                            react_1.default.createElement(core_ui_1.Input, { name: "policyNumber", type: "text", value: form.values.policyNumber, onChange: function (value) { return form.setFieldValue('policyNumber', value); } })),
                        react_1.default.createElement(core_ui_1.Field, { label: "Policy type", fieldId: "lineOfCoverage", error: form.errors.type },
                            react_1.default.createElement(policy_type_select_input_1.PolicyTypeSelectInput, { value: form.values.type, onChange: function (value) { return form.setFieldValue('type', value); } })),
                        react_1.default.createElement(core_ui_1.Field, { label: "Carrier", fieldId: "carriers", error: (_c = (_b = form.errors.marketAccess) === null || _b === void 0 ? void 0 : _b.carrier) === null || _c === void 0 ? void 0 : _c.name },
                            react_1.default.createElement(carrier_select_1.CarrierSelect, { name: "carriers", data: (_d = insuranceProvidersData === null || insuranceProvidersData === void 0 ? void 0 : insuranceProvidersData.insuranceProviders) === null || _d === void 0 ? void 0 : _d.carriers, onChange: function (carrierId) {
                                    var _a;
                                    form.setFieldValue('marketAccess.carrier', (_a = insuranceProvidersData === null || insuranceProvidersData === void 0 ? void 0 : insuranceProvidersData.insuranceProviders) === null || _a === void 0 ? void 0 : _a.carriers.find(function (item) { return item.id === carrierId; }));
                                }, value: form.values.marketAccess.carrier.id, showSelectAnOption: true })),
                        react_1.default.createElement(core_ui_1.Field, { label: "Third party", fieldId: "thirdParty" },
                            react_1.default.createElement(wholesaler_select_1.WholesalerSelect, { data: (_e = insuranceProvidersData === null || insuranceProvidersData === void 0 ? void 0 : insuranceProvidersData.insuranceProviders) === null || _e === void 0 ? void 0 : _e.thirdParties, name: "thirdParty", onChange: function (wholesalerId) {
                                    var _a;
                                    return form.setFieldValue('marketAccess.wholesaler', (_a = insuranceProvidersData === null || insuranceProvidersData === void 0 ? void 0 : insuranceProvidersData.insuranceProviders) === null || _a === void 0 ? void 0 : _a.thirdParties.find(function (item) { return item.id === wholesalerId; }));
                                }, value: (_f = form.values.marketAccess.wholesaler) === null || _f === void 0 ? void 0 : _f.id, showSelectAnOption: true })),
                        react_1.default.createElement(policy_term_fields_1.PolicyTermFields, { values: {
                                policyTerm: legacy_1.legacyParsePolicyTermFromString(form.values.policyTerm),
                                effectiveDate: form.values.effectiveDate,
                                expirationDate: form.values.expirationDate,
                            }, onChange: function (_a) {
                                var policyTerm = _a.policyTerm, effectiveDate = _a.effectiveDate, expirationDate = _a.expirationDate;
                                form.setFieldValue('policyTerm', legacy_1.legacyConvertPolicyTermIntoString(policyTerm));
                                form.setFieldValue('effectiveDate', effectiveDate);
                                form.setFieldValue('expirationDate', expirationDate);
                            }, errors: form.errors }),
                        react_1.default.createElement(core_ui_1.Field, { label: "Premium", fieldId: "premium", error: form.errors.premium },
                            react_1.default.createElement(core_ui_1.CurrencyInput, { name: "premium", value: form.values.premium || undefined, onChange: function (value) { return form.setFieldValue('premium', value); } })))),
                react_1.default.createElement(core_ui_1.ModalFooter, { showBorder: true },
                    react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "horizontal", justifyContent: "flex-end" },
                        react_1.default.createElement(core_ui_1.Button, { onClick: handleToggle, disabled: isSubmitting, size: "secondary" }, "Cancel"),
                        react_1.default.createElement(core_ui_1.Button, { type: "submit", loading: isSubmitting, disabled: !form.isValid || isSubmitting }, submitText)))))));
}
exports.AddHistoricalPoliciesModal = AddHistoricalPoliciesModal;
